import * as React from "react";
import {CSSTransition, TransitionGroup} from "react-transition-group";
import { cx } from "emotion";
import {Fragment} from "react";

import "./modal-service.scss";

import {cs}       from "@Common/react/chain-services";
import {Static2}  from "@Common/react/static-2";
import {UseState} from "@Common/react/use-state";
import {chain}    from "@Common/utils/fs";

import {OnGlobalKeyDownEscape} from "../../../../browser/global-key-down-escape";
import {Link} from "../../../../../react/cst2";

type MetaRender = {
    size           ?: number | string,
    content         : React.ReactNode,
    onPassiveClose ?: () => (boolean | void),
};

export const DeprecatedModalService2 = <Params,>(
    {
        render=undefined, initShow=undefined, service=undefined, onPassiveClose=undefined, hideCloseButton=false,
        top=undefined, zIndex=undefined, xdQaName=undefined,
        next=undefined,
    }:{
        hideCloseButton ?: boolean,
        initShow        ?: boolean,
        next            ?: Link<React.ReactNode, {show: (params: Params) => void}>,
        render          ?: (params: any, setParams: (params?: Params) => void) => MetaRender,
        service         ?: (
            params: any,
            setParams: (params?: Params) => void,
            next: Link<React.ReactNode, MetaRender>
        ) => React.ReactNode,
        onPassiveClose  ?: () => (boolean | void),
        top             ?: number,
        xdQaName        ?: string,
        zIndex          ?: number,
    }
) => cs(
    ["state", (_, next) => UseState({
        getInitValue: () => ({show: initShow}),
        next,
    })],
    ["overlayDom", (_, next) => Static2({next})],
    ({overlayDom, state}) => <>
        {next?.({
            show: (params = true) => state.onChange({show: params}),
        })}

        {cs(
            ({}, next) => (
                <TransitionGroup component={Fragment}>
                    {next()}
                </TransitionGroup>
            ),
            ({}, next) => state.value.show && next(),

            ({}, next) => (
                <CSSTransition
                    classNames={"up"}
                    timeout={300}
                >
                    {next()}
                </CSSTransition>
            ),
            ["r", (_, next) => chain(
                (service || ((params, onChange, next) => next(render(params, onChange)))),
                (service) => service(state.value.show, (params) => state.onChange({show: params}), next)
            )],
            ["passiveClose", ({r}, next) => next(async () => {
                const hide = await (r.onPassiveClose || onPassiveClose || null)?.();
                if (hide !== false) {
                    state.onChange({show: false});
                }
            })],
            ({r, passiveClose}) => (

                <div
                    className="modal-overlay-94d"
                    onClick={(e) => {
                        e.stopPropagation();
                        if (e.target === overlayDom.get()) {
                            passiveClose();
                        }
                    }}
                    ref={ref => overlayDom.set(ref)}
                    style={{zIndex}}
                >
                    {OnGlobalKeyDownEscape({
                        action: passiveClose,
                    })}

                    <div
                        className={cx("fixed-box", typeof r.size === "string" && r.size)}
                        style={{
                            ...typeof r.size === "number" && {
                                maxWidth: r.size * (window.innerWidth >= 1920 ? 1.43 : 1),
                            },
                            ...top && {
                                marginTop: top,
                            }
                        }}

                    >

                        <div className="content">
                            {r.content}
                        </div>

                        {!hideCloseButton && (
                            <button
                                className="close-btn close-padding"
                                xd-qa-type="icon"
                                xd-qa-name={(xdQaName ? xdQaName : "Modal Overlay") + " Close"}
                                onClick={() => {
                                    passiveClose();
                                }}
                            >
                                &times;
                            </button>
                        )}
                    </div>
                </div>
            ),
        )}
    </>
);
